import React from 'react';
import { Route, Routes, useParams, Navigate } from 'react-router-dom';
import { PiersProvider } from './context/PiersContext';
import PiersView from './components/PiersView';
import { STATION_CONFIGS } from '../../config/stationConfigs';

const PiersModule = () => {
  const { station } = useParams();

  // Validate station code
  if (!station || !STATION_CONFIGS[station]) {
    return <Navigate to="/" replace />;
  }

  return (
    <PiersProvider key={station} station={station}>
      <Routes>
        <Route path="/" element={<PiersView />} />
      </Routes>
    </PiersProvider>
  );
};

export default PiersModule;
